import { createContext, PropsWithChildren, useCallback } from "react";
import { useModal } from "@ludens-reklame/react-modal";
import { Form } from "@ludens-reklame/rubics-v3-sdk/form/types";
import { FormModal } from "../internal-components/form-modal/form-modal.js";

interface IAppContext {
  spawnContactFormModal: (form: Form) => void;
}

export const AppContext = createContext<IAppContext>({
  spawnContactFormModal: () => {},
});

export const AppProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { spawnModal, despawnModal } = useModal();

  const spawnContactFormModal = useCallback(
    (form: Form) => {
      return spawnModal(<FormModal despawnModal={despawnModal} form={form} />);
    },
    [spawnModal, despawnModal],
  );

  return (
    <AppContext.Provider
      value={{
        spawnContactFormModal,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
